import { render, staticRenderFns } from "./howToKnowTermsOfCommissions.vue?vue&type=template&id=6d7c4b09&scoped=true"
import script from "./howToKnowTermsOfCommissions.vue?vue&type=script&lang=js"
export * from "./howToKnowTermsOfCommissions.vue?vue&type=script&lang=js"
import style0 from "./howToKnowTermsOfCommissions.vue?vue&type=style&index=0&id=6d7c4b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c4b09",
  null
  
)

export default component.exports